import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule } from '@angular/forms';
import { ContactsModule } from "@components/contacts";
import { DateTimeEntryModule } from "@components/date-time-entry";
import { ChecklistsModule } from "@shared-components/checklists";
import { ChecklistDisplayModule } from "@shared-components/checklist-display"
import { SlickButtonSpinnerModule, SlickContainerModule, SlickDatePickerModule, SlickDialogModule, SlickDropDownModule, SlickMultiSelectPillsModule, SlickStarRatingModule, SlickTabsModule, SlickToastModule, SlickValidationIndicatorModule } from "slick-components";
import { NotesModule } from "@components/notes";
import { SharedModule } from "@components";

import { BusinessDevelopmentAccountViewComponent } from "./business-development-account-view/business-development-account-view.component";
import { BusinessDevelopmentAccountTypesDialogComponent } from "./business-development-account-view/business-development-account-types-dialog/business-development-account-types-dialog.component";
import { BusinessDevelopmentAccountEditDialogComponent } from "./business-development-account-edit-dialog/business-development-account-edit-dialog.component";
import { BusinessDevelopmentContactEditDialogComponent } from "./business-development-contact-edit-dialog/business-development-contact-edit-dialog.component";
import { BusinessDevelopmentNotesComponent } from "./business-development-notes/business-development-notes.component";
import { BusinessDevelopmentContactRolesComponent } from "./business-development-contact-edit-dialog/business-development-contact-roles-dialog/business-development-contact-roles-dialog.component";

@NgModule({
	imports: [
		CommonModule,
		FormsModule,
		SharedModule,
		NotesModule,
		ContactsModule,
		ChecklistsModule,
		ChecklistDisplayModule,
		DateTimeEntryModule,
		SlickButtonSpinnerModule, SlickContainerModule, SlickDatePickerModule, SlickDialogModule, SlickDropDownModule, SlickMultiSelectPillsModule, SlickStarRatingModule, SlickTabsModule, SlickToastModule, SlickValidationIndicatorModule
	],
	declarations: [BusinessDevelopmentAccountViewComponent, BusinessDevelopmentAccountTypesDialogComponent, BusinessDevelopmentAccountEditDialogComponent, BusinessDevelopmentContactEditDialogComponent, BusinessDevelopmentNotesComponent, BusinessDevelopmentContactRolesComponent],
	exports: [BusinessDevelopmentAccountViewComponent, BusinessDevelopmentAccountEditDialogComponent, BusinessDevelopmentContactEditDialogComponent]
})
export class BusinessDevelopmentComponentsModule { }

export { BusinessDevelopmentAccountEditDialogComponent } from "./business-development-account-edit-dialog/business-development-account-edit-dialog.component";
export { BusinessDevelopmentContactEditDialogComponent } from "./business-development-contact-edit-dialog/business-development-contact-edit-dialog.component";
